/* スターターセットLP: 購入者レビュー
 *
 * Prime Review のレビューはアプリ所有のメタフィールドに入っており、テーマの Liquid からは読めない。
 * このテーマでは既に desktop-pc-prime-reviews.js が「商品ページを取得して
 * Prime Review が描画した DOM を読み取る」方式を採っているので、それに揃える。
 *
 * 取得できなければ何も描画しない。Liquid 側は手入力のレビューブロックを
 * 先に出しているので、失敗時はそのまま残る。
 */
(function () {
  'use strict';
  /* 同じスクリプトを複数セクションが読み込むため <script> は何本も出力される。
     ブラウザはタグごとに実行するので、ガードが無いと処理が重複する。 */
  if (window.mdlLpReviewsReady) return;
  window.mdlLpReviewsReady = true;

  var STAR_PATH = 'M12 2.5l2.9 5.9 6.6 1-4.8 4.6 1.1 6.5L12 17.4l-5.8 3.1 1.1-6.5-4.8-4.6 6.6-1z';

  function star(kind, gradientId) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '18');
    svg.setAttribute('height', '18');
    svg.setAttribute('focusable', 'false');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', STAR_PATH);
    if (kind === 'half') path.setAttribute('fill', 'url(#' + gradientId + ')');
    else if (kind === 'empty') path.setAttribute('fill', 'var(--color-border)');
    else svg.setAttribute('fill', 'currentColor');
    svg.appendChild(path);
    return svg;
  }

  function stars(rating, gradientId) {
    var wrap = document.createElement('span');
    wrap.className = 'rating__stars';
    wrap.setAttribute('aria-hidden', 'true');
    var full = Math.floor(rating);
    var half = rating - full >= 0.25;
    for (var i = 1; i <= 5; i++) {
      if (i <= full) wrap.appendChild(star('full'));
      else if (half && i === full + 1) wrap.appendChild(star('half', gradientId));
      else wrap.appendChild(star('empty'));
    }
    return wrap;
  }

  /** Prime Review が描画した DOM からレビューを取り出す */
  function extractReviews(html, sel) {
    var doc;
    try {
      doc = new DOMParser().parseFromString(html, 'text/html');
    } catch (e) {
      return [];
    }
    return Array.prototype.slice.call(doc.querySelectorAll(sel.item)).map(function (el) {
      var bodyEl = el.querySelector(sel.body);
      var body = bodyEl ? (bodyEl.textContent || '').trim().replace(/\s+/g, ' ') : '';

      // 星は塗り幅の % で表現されている。20% = 1つ
      var starEl = el.querySelector(sel.score);
      var score = 0;
      if (starEl) {
        var m = (starEl.getAttribute('style') || '').match(/width:\s*([\d.]+)%/);
        if (m) score = Math.round((parseFloat(m[1]) / 20) * 10) / 10;
      }

      var nameEl = el.querySelector(sel.author);
      var titleEl = sel.title ? el.querySelector(sel.title) : null;
      return {
        body: body,
        score: score,
        author: nameEl ? (nameEl.textContent || '').trim() : '',
        title: titleEl ? (titleEl.textContent || '').trim() : ''
      };
    }).filter(function (r) { return r.body; });
  }

  function buildCard(review, gradientId, suffix) {
    var article = document.createElement('article');
    article.className = 'review';

    var meta = document.createElement('div');
    meta.className = 'review__meta';

    var rating = document.createElement('span');
    rating.className = 'rating';
    rating.appendChild(stars(review.score, gradientId));

    var score = document.createElement('span');
    score.className = 'rating__score num';
    score.textContent = review.score.toFixed(1);
    rating.appendChild(score);

    var sr = document.createElement('span');
    sr.className = 'visually-hidden';
    sr.textContent = '5点満点中' + review.score.toFixed(1);
    rating.appendChild(sr);
    meta.appendChild(rating);

    if (review.title || review.author) {
      var author = document.createElement('span');
      author.className = 'review__author';
      if (review.title) {
        var tag = document.createElement('span');
        tag.className = 'tag';
        tag.textContent = review.title;
        author.appendChild(tag);
      }
      author.appendChild(document.createTextNode(review.author + (suffix || '')));
      meta.appendChild(author);
    }
    article.appendChild(meta);

    var body = document.createElement('p');
    body.className = 'review__body';
    body.textContent = review.body;
    article.appendChild(body);

    return article;
  }

  function init(root) {
    var handle = root.getAttribute('data-handle');
    var list = root.querySelector('[data-mdl-lp-review-list]');
    if (!handle || !list) return;

    var limit = parseInt(root.getAttribute('data-limit'), 10) || 3;
    var minScore = parseFloat(root.getAttribute('data-min-rating')) || 0;
    var gradientId = root.getAttribute('data-gradient');
    var suffix = root.getAttribute('data-author-suffix') || '';
    var sel = {
      item: root.getAttribute('data-item-sel'),
      body: root.getAttribute('data-body-sel'),
      score: root.getAttribute('data-score-sel'),
      author: root.getAttribute('data-author-sel'),
      title: root.getAttribute('data-title-sel')
    };

    // レビューだけを返す代替テンプレート。商品ページ全体は5MB近くあり、取得が重い
    fetch('/products/' + handle + '?view=mdl-lp-reviews', { credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.text() : ''; })
      .then(function (html) {
        var picked = extractReviews(html, sel)
          .filter(function (r) { return r.score >= minScore; })
          .sort(function (a, b) { return b.score - a.score; })
          .slice(0, limit);
        if (!picked.length) return;

        list.textContent = '';
        picked.forEach(function (r) { list.appendChild(buildCard(r, gradientId, suffix)); });
      })
      .catch(function () { /* 取得できなければ手入力のレビューをそのまま残す */ });
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-mdl-lp-reviews]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
